document.addEventListener("scroll", () => {
  const content = document.querySelector(".parallax-footer__content");
  if (!content || window.innerWidth < 768) return;

  const scrollTop = window.scrollY;
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;

  // Check if we're at the bottom of the window (with a small buffer of 10px)
  const isAtBottom = (scrollTop + windowHeight >= documentHeight - 10);

  if (isAtBottom) {
    content.style.opacity = 1; // Fully visible at the bottom
  } else {
    // Calculate opacity based on how close we are to the bottom of the window
    const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
    const fadeStart = 800; // Start fading in when this many pixels from bottom
    let opacity = 1 - (distanceFromBottom / fadeStart);
    opacity = Math.max(0, Math.min(1, opacity)); // Clamp opacity between 0 and 1
    content.style.opacity = opacity;
  }
});